<div class="card" (click)="cardClicked.emit()" *ngIf="office$ | ngrxPush as office">
    <div class="card-body p-2">
        <div class="flex flex-row items-center gap-2">
            <app-office-avatar [officeId]="office.officeId" [companyId]="office.companyId" avatarClasses="w-[64px]"></app-office-avatar>

            <div class="flex flex-col">
                <h4 class="mb-0">{{ office.name }}</h4>

                <span class="text-sm">{{ office.companyOfficeNumber }}</span>

                <span class="badge badge-error badge-outline mt-2 w-3/4" *ngIf="office.deactivated" i18n>Deactivated</span>
            </div>
        </div>

        <table class="table table-compact" *ngIf="displayAdditionalInfo">
            <tbody>
                <tr *ngIf="address$ | ngrxPush as address">
                    <th i18n>Address:</th>
                    <td class="break-words whitespace-pre-wrap">{{ address }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
